import { render } from "./StorageItemsPanel.vue?vue&type=template&id=04f23f4e"
import script from "./StorageItemsPanel.vue?vue&type=script&lang=js"
export * from "./StorageItemsPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QKnob from 'quasar/src/components/knob/QKnob.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QKnob,QAvatar});
